<template>
  <div>
    <TitlePage :title="$t('settings')+' '+$t('field')+ ' - ' + description"></TitlePage>

    <v-layout wrap>

      <v-card>

        <v-tabs v-model="tab" background-color="accent" dark>
          <v-tabs-slider color="green"></v-tabs-slider>

          <v-tab href="#tab-1">
            <v-icon small class="mr-2">mdi-hand-coin</v-icon>
            {{ $tc('price', 2) }}
          </v-tab>

          <v-tab href="#tab-2" @click="goToMasterCalendar">
            <v-icon small class="mr-2">mdi-calendar</v-icon>
            {{ $t('masterCalendar') }}
          </v-tab>

          <v-tab href="#tab-3" @click="goTocalendar">
            <v-icon small class="mr-2">mdi-calendar</v-icon>
            {{ $t('calendar') }}
          </v-tab>

        </v-tabs>

        <v-tabs-items v-model="tab" touchless>
          <v-tab-item :value="'tab-1'">
            <v-card class="pa-3 pt-5 pb-5">

              <v-layout wrap>
                <v-flex md12 xs12 class="d-flex">
                  <v-chip color="primary" label small text-color="white">{{
                      $tc('price', 2)
                    }}
                  </v-chip>
                </v-flex>

                <v-flex md2 xs12 class="pl-4 pr-4" v-for="price in item.price"
                        :key="'price_'+price.sport_id">
                  <v-text-field type="number" :label="getSportName(price.sport_id)"
                                v-model="price.value" prefix="€"
                                step="0.50" @input="changePercentage">
                  </v-text-field>
                </v-flex>

                <v-flex md2 xs12 class="pl-4 pr-4">
                  <v-text-field type="number" :label="$t('minCost')" v-model="item.rules.min_price"
                                prefix="€"
                                step="0.50">
                  </v-text-field>
                </v-flex>

                <v-flex md12 xs12 class="d-flex">
                  <v-chip color="primary" label small text-color="white">{{
                      $t('splitPaymentMaster')
                    }}
                  </v-chip>
                </v-flex>

                <v-flex md3 xs12 class="pl-4 pr-4">
                  <v-select :items="split_payment_types" :label="$t('mode')"
                            v-model="split_payment_master_selected"
                            @change="applySplit"></v-select>
                </v-flex>

                <template>
                  <v-flex md2 xs12 class="pl-4 pr-4">
                    <v-text-field type="number" :label="$t('onlinePercentage')"
                                  v-model="item.split_payment_master.online_percentage" prefix="%"
                                  step="1"
                                  @input="changePercentage('online')" min="0"
                                  max="100"></v-text-field>
                  </v-flex>
                  <v-flex md2 xs12 class="pl-4 pr-4">
                    <v-text-field type="number" :label="$t('centerPercentage')"
                                  v-model="item.split_payment_master.center_percentage" prefix="%"
                                  step="1"
                                  @input="changePercentage('center')" min="0"
                                  max="100"></v-text-field>
                  </v-flex>

                  <v-flex md12 xs12 class="d-flex">
                    <v-chip color="primary" label small text-color="white">Opzione Mezz'ora aggiuntiva</v-chip>
                  </v-flex>

                  <v-flex md12 xs12 class="pl-4 pr-4">
                    <small style="color: red">Attenzione, abilitando questa opzione non sarà possibile creare fasce orarie sovrapposte</small>
                  </v-flex>


                  <v-flex md1 xs12 class="d-flex pt-2 pb-2 pl-4 pr-4">
                    <v-switch class="mt-2" dense inset hide-details
                              v-model="item.half_hour_enabled"
                              :color="(item.half_hour_enabled)?'green':'grey'"
                    ></v-switch>
                  </v-flex>

                  <v-flex md2 xs12 class="pl-4 pr-4" v-for="price in item.half_hour_price"
                          :key="'price_hf_'+price.sport_id">
                    <v-text-field type="number" :label="getSportName(price.sport_id)"
                                  v-model="price.value" prefix="€"
                                  step="0.50">
                    </v-text-field>
                  </v-flex>

                  <v-flex md12 class="d-flex pt-5">
                    <v-chip color="primary" label small text-color="white">{{$t('settings')}} {{$t('PromoCode')}}</v-chip>
                  </v-flex>

                  <v-flex md4 class="pl-4 pr-4">
                    <v-checkbox
                        v-model="item.enable_promo_code_promo_sa_global"
                        label="Accetta Promo Code uCamp"
                        :readonly="!this.getUser.super_admin"
                        :disabled="!this.getUser.super_admin"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex md4 class="pl-4 pr-4">
                    <v-checkbox
                        v-model="item.enable_promo_code_promo_center"
                        label="Accetta Promo Code Centro"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex md12 xs12 class="d-flex">
                    <v-chip color="primary" label small text-color="white">{{
                        $t('preview')
                      }}
                    </v-chip>
                  </v-flex>

                  <v-flex md12 xs12 class="pl-4 pr-4 pb-3">
                    <v-simple-table dense>
                      <thead>
                      <tr>
                        <th class="text-left">Sport</th>
                        <th class="text-left">Da Pagare Online</th>
                        <th class="text-left">Da Pagare al Campo</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="preview in preview_price" :key="'preview_'+preview.sport_id">
                        <td class="font-weight-bold">{{ getSportName(preview.sport_id) }}</td>
                        <td>
                          <span v-bind:style="[+preview.value_ac < +item.rules.min_price? {'color':'red'} : {}]">
                          <template v-if="+preview.value_ac < +item.rules.min_price">*</template> {{
                              preview.value_ac.toFixed(2)
                            }} €
                          </span>
                        </td>
                        <td>{{ preview.value_ce.toFixed(2) }} €</td>
                      </tr>
                      </tbody>
                    </v-simple-table>
                    <small style="color: red">* Al di sotto del minimo costo garantito</small>

                  </v-flex>

                </template>
              </v-layout>
            </v-card>
          </v-tab-item>

          <v-tab-item :value="'tab-2'">
            <v-card class="pa-3 pt-5 pb-5">
              <v-layout wrap>

                <v-flex md12 xs12 class="d-flex">
                  <v-chip color="primary" label small text-color="white">{{
                      $t('configurations')
                    }}
                  </v-chip>
                </v-flex>

                <v-flex md2 xs12 class="pl-4 pr-4">
                  <v-text-field type="number" :label="$t('limitBooking')+' ('+$tc('minute',2)+')'"
                                v-model="item.rules.limit_time" :hint="$t('limitBookingHint')">
                  </v-text-field>
                </v-flex>

                <v-flex md2 xs12 class="pl-4 pr-4" offset-md="10">
                  <v-text-field type="number" :label="$t('limitViewCalendar')+' ('+$tc('day',2)+')'"
                                v-model="item.rules.calendar_days_view"
                                :hint="$t('limitViewCalendarHint')"></v-text-field>
                </v-flex>

                <v-flex md12 xs12 class="d-flex">
                  <v-chip color="primary" label small text-color="white">{{
                      $t('timeSlots')
                    }}
                  </v-chip>
                </v-flex>


                <v-flex md2 xs12 class="pl-4 pr-4">
                  <v-text-field type="number" :label="$t('slotTime')+' ('+$tc('minute',2)+')'"
                                v-model="item.rules.slot_time"></v-text-field>
                </v-flex>

                <v-flex md2 xs12 class="pl-4 pr-4">
                  <v-menu ref="menu_open" v-model="menu_ot" :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="item.rules.open_time"
                          transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="item.rules.open_time" :label="$t('openTime')"
                                    prepend-icon="mdi-clock-time-four-outline" readonly
                                    v-bind="attrs" v-on="on">
                      </v-text-field>
                    </template>
                    <v-time-picker v-if="menu_ot" v-model="item.rules.open_time" full-width
                                   @click:minute="$refs.menu_open.save(item.rules.open_time)"
                                   format="24hr"></v-time-picker>
                  </v-menu>
                </v-flex>

                <v-flex md2 xs12 class="pl-4 pr-4">
                  <v-menu ref="menu_close" v-model="menu_ct" :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="item.rules.close_time"
                          transition="scale-transition" offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="item.rules.close_time" :label="$t('closeTime')"
                                    prepend-icon="mdi-clock-time-four-outline" readonly
                                    v-bind="attrs" v-on="on">
                      </v-text-field>
                    </template>
                    <v-time-picker v-if="menu_ct" v-model="item.rules.close_time" full-width
                                   @click:minute="$refs.menu_close.save(item.rules.close_time)"
                                   format="24hr"></v-time-picker>
                  </v-menu>
                </v-flex>

                <v-flex offset-md-6></v-flex>

                <v-flex md2 xs12 class="pl-4 pr-4" v-for="priceForGen in priceForSlots"
                        :key="'price_for_gen'+priceForGen.sport_id">
                  <v-text-field type="number" :label="getSportName(priceForGen.sport_id)"
                                v-model="priceForGen.value" prefix="€"
                                step="0.50">
                  </v-text-field>
                </v-flex>

                <v-flex md2 xs12 class="pl-4 pr-4">
                  <v-checkbox color="primary" hide-details class="mt-3 pt-0 mb-0 pb-0" v-model="reset_time_slots">
                    <template v-slot:label>
                      <div>
                        Rimuovi slot esistenti
                      </div>
                    </template>
                  </v-checkbox>
                </v-flex>

                <v-flex md2 xs12 class="pl-4 pr-4">
                  <v-btn elevation="2" color="primary" small class="mr-2 mt-3"
                         @click="generateTimeSlots">
                    <v-icon left>mdi-card-search</v-icon>
                    {{ $t('generateSlots') }}
                  </v-btn>
                </v-flex>

                <v-flex offset-md-4></v-flex>

                <v-flex md12 xs12 class="pl-4 pr-4">
                  <v-simple-table dense v-if="item.master_calendar">
                    <thead>
                    <tr>
                      <th v-for="header in headers" :key="'head_'+header.name"
                          @click="addAll(header.day)" style="cursor: pointer">
                        <v-icon left dense>
                          {{
                            (item.master_calendar[header.day].filter(e => !e.active).length === 0) ?
                                'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'
                          }}
                        </v-icon>
                        {{ header.name }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr class="" v-for="(slot, slot_index) in this.master_calendar_depth" :key="'time_slot'+slot_index">
                      <template v-for="header in headers" v-if="item.master_calendar[header.day][slot_index]">
                        <td class="ma-0 pa-0">
                          <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" small>
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list dense>
                              <template>
                                <v-list-item dense
                                             @click="addNewSlot(header.day,item.master_calendar[header.day][slot_index])">
                                  Aggiungi Nuovo
                                </v-list-item>
                                <v-list-item dense
                                             @click="editSlot(header.day,item.master_calendar[header.day][slot_index])"
                                             v-if="item.master_calendar[header.day][slot_index].active">
                                  Modifica
                                </v-list-item>
                                <v-list-item dense
                                             @click="confirmRemove(header.day,item.master_calendar[header.day][slot_index])">
                                  Elimina
                                </v-list-item>
                              </template>
                            </v-list>
                          </v-menu>
                          <v-chip
                              @click="enableSlot(item.master_calendar[header.day][slot_index])"
                              small :color="(item.master_calendar[header.day][slot_index].active) ? 'green':'gray'"
                              :text-color="(item.master_calendar[header.day][slot_index].active) ? 'white':'gray'"
                          >
                            {{ item.master_calendar[header.day][slot_index].start }} -
                            {{ item.master_calendar[header.day][slot_index].end }}
                          </v-chip>
                          <v-icon v-if="item.master_calendar[header.day][slot_index].active"
                                  :color="item.master_calendar[header.day][slot_index].split_payment ? 'red':'primary'"
                                  @click="overrideSlot(header.day,item.master_calendar[header.day][slot_index])">
                            mdi-contactless-payment-circle
                          </v-icon>
                          <v-icon v-else color="gray">mdi-contactless-payment-circle-outline</v-icon>
                        </td>
                      </template>
                      <template v-else>
                        <td class="ma-0 pa-0 text-center">
                          -
                        </td>
                      </template>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </v-flex>
              </v-layout>
            </v-card>
          </v-tab-item>

          <v-tab-item :value="'tab-3'">

          </v-tab-item>
        </v-tabs-items>
      </v-card>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="update" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
        <template v-if="tab === 'tab-1'">
          <v-btn elevation="2" color="primary" class="ml-2" @click="update('master')" type="submit">
            {{ $t('save') }} E VAI AL {{ $t('masterCalendar') }}
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </template>
        <template v-if="tab === 'tab-2'">
          <v-btn elevation="2" color="primary" class="ml-2" @click="update('calendar')" type="submit">
            {{ $t('save') }} E VAI AL {{ $t('calendar') }}
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </template>
      </v-flex>


    </v-layout>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

    <v-dialog v-model="dialog_split_payment" persistent max-width="800px" v-if="slot_to_override">
      <v-card>
        <v-card-title>
          <span class="font-weight-bold">{{ this.override_title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <template>
                <v-flex md12 xs12 class="d-flex">
                  <v-chip color="primary" label small text-color="white">{{
                      $t('splitPayment')
                    }}
                  </v-chip>
                </v-flex>
                <v-flex md4 xs12 class="pl-4 pr-4">
                  <v-select :items="split_payment_types" :label="$t('mode')"
                            v-model="split_payment_override_selected"
                            @change="applySplitOverride"></v-select>
                </v-flex>
                <v-flex md4 xs12 class="pl-4 pr-4">
                  <v-text-field type="number" :label="$t('onlinePercentage')"
                                v-model="slot_to_override.online_percentage" prefix="%" step="1"
                                @input="changePercentageOverride('online')" min="0"
                                max="100"></v-text-field>
                </v-flex>
                <v-flex md4 xs12 class="pl-4 pr-4">
                  <v-text-field type="number" :label="$t('centerPercentage')"
                                v-model="slot_to_override.center_percentage" prefix="%" step="1"
                                @input="changePercentageOverride('center')" min="0"
                                max="100"></v-text-field>
                </v-flex>
                <v-flex md12 xs12 class="d-flex">
                  <v-chip color="primary" label small text-color="white">{{
                      $tc('promotion')
                    }}
                  </v-chip>
                </v-flex>
                <v-flex md4 xs12 class="pl-4 pr-4">
                  <v-select :items="promotion_types" :label="$t('mode')"
                            v-model="slot_to_override.promo_type"
                            @change="calculateTotalsOverride"></v-select>
                </v-flex>
                <v-flex md4 xs12 class="pl-4 pr-4" v-if="slot_to_override.promo_type != null">
                  <v-text-field type="number" :label="$t('value')"
                                v-model="slot_to_override.promo_value"
                                :prefix="(slot_to_override.promo_type === 'fixed') ? '-':'%'" step="1"
                                @input="calculateTotalsOverride" min="0" max="100"></v-text-field>
                </v-flex>

                <v-flex md12 xs12 class="d-flex">
                  <v-chip color="primary" label small text-color="white">{{ $t('preview') }}</v-chip>
                </v-flex>

                <v-flex md12 xs12 class="pl-4 pr-4 pb-3">
                  <v-simple-table dense>
                    <thead>
                    <tr>
                      <th class="text-left">Sport</th>
                      <th class="text-left">Da Pagare Online</th>
                      <th class="text-left">Da Pagare al Campo</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="preview_ov in preview_price_override"
                        :key="'preview_ov_'+preview_ov.sport_id">
                      <td class="font-weight-bold">{{ getSportName(preview_ov.sport_id) }}</td>
                      <td>
                          <span v-bind:style="[+preview_ov.value_ac < +item.rules.min_price? {'color':'red'} : {}]">
                          <template v-if="+preview_ov.value_ac < +item.rules.min_price">*</template> {{
                              preview_ov.value_ac.toFixed(2)
                            }} €
                          </span>
                      </td>
                      <td>{{ preview_ov.value_ce.toFixed(2) }} €</td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                  <small style="color: red">* Al di sotto del minimo costo garantito</small>

                </v-flex>

              </template>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="buttons-group-mobile">
          <v-btn color="secondary" text @click="dialog_split_payment = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="deleteOverride()"
                 v-if="slot_to_override.center_percentage != null && slot_to_override.online_percentage != null">
            {{ $t('deleteOverride') }}
          </v-btn>
          <v-btn color="primary" @click="saveOverride()">
            {{ $t('insert') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_slot_to_edit" persistent max-width="800px" v-if="slot_to_edit">
      <v-card>
        <v-card-title>
          <span class="font-weight-bold">{{ this.edit_title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <template>
                <v-flex md6 xs12 class="pl-4 pr-4">
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    Orario di inizio
                  </v-flex>
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    <v-text-field type="number" v-model="slot_to_edit.start_h"
                                  hint="hh"
                                  step="1" max="23" min="0" @change="calculateSlotTotals('edit')">
                    </v-text-field>
                  </v-flex>
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    <v-text-field type="number" v-model="slot_to_edit.start_m"
                                  hint="mm"
                                  step="1" max="59" min="0" @change="calculateSlotTotals('edit')">
                    </v-text-field>
                  </v-flex>
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    Orario di fine
                  </v-flex>
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    <v-text-field type="number" v-model="slot_to_edit.end_h"
                                  hint="hh"
                                  step="1" max="23" min="0" @change="calculateSlotTotals('edit')">
                    </v-text-field>
                  </v-flex>
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    <v-text-field type="number" v-model="slot_to_edit.end_m"
                                  hint="mm"
                                  step="1" max="59" min="0" @change="calculateSlotTotals('edit')">
                    </v-text-field>
                  </v-flex>
                </v-flex>
                <v-flex md6 xs12 class="pl-4 pr-4">
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    Durata slot: {{ getSlotDurationInMinutes('edit') }} minuti
                  </v-flex>

                  <v-flex md12 xs12 class="pl-4 pr-4" v-for="price in slot_to_edit.slot_price"
                          :key="'price_'+price.sport_id+'_'+slot_to_edit.id">
                    <v-text-field type="number" :label="getSportName(price.sport_id)"
                                  v-model="price.value" prefix="€"
                                  step="0.50">
                    </v-text-field>
                  </v-flex>
                </v-flex>
              </template>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="buttons-group-mobile">
          <v-btn color="secondary" text @click="dialog_slot_to_edit = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="insertSlotUpdated()">
            {{ $t('insert') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_slot_to_add" persistent max-width="800px" v-if="slot_to_add">
      <v-card>
        <v-card-title>
          <span class="font-weight-bold">{{ this.add_title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <template>
                <v-flex md6 xs12 class="pl-4 pr-4">
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    Orario di inizio
                  </v-flex>
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    <v-text-field type="number" v-model="slot_to_add.start_h"
                                  hint="hh"
                                  step="1" max="23" min="0" @change="calculateSlotTotals('add')">
                    </v-text-field>
                  </v-flex>
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    <v-text-field type="number" v-model="slot_to_add.start_m"
                                  hint="mm"
                                  step="1" max="59" min="0" @change="calculateSlotTotals('add')">
                    </v-text-field>
                  </v-flex>
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    Orario di fine
                  </v-flex>
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    <v-text-field type="number" v-model="slot_to_add.end_h"
                                  hint="hh"
                                  step="1" max="23" min="0" @change="calculateSlotTotals('add')">
                    </v-text-field>
                  </v-flex>
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    <v-text-field type="number" v-model="slot_to_add.end_m"
                                  hint="mm"
                                  step="1" max="59" min="0" @change="calculateSlotTotals('add')">
                    </v-text-field>
                  </v-flex>
                </v-flex>
                <v-flex md6 xs12 class="pl-4 pr-4">
                  <v-flex md12 xs12 class="pl-4 pr-4">
                    Durata slot: {{ getSlotDurationInMinutes('add') }} minuti
                  </v-flex>

                  <v-flex md12 xs12 class="pl-4 pr-4" v-for="price in slot_to_add.slot_price"
                          :key="'price_'+price.sport_id">
                    <v-text-field type="number" :label="getSportName(price.sport_id)"
                                  v-model="price.value" prefix="€"
                                  step="0.50">
                    </v-text-field>
                  </v-flex>
                </v-flex>
              </template>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="buttons-group-mobile">
          <v-btn color="secondary" text @click="dialog_slot_to_add = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="insertSlotToAdd()">
            {{ $t('insert') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";

// Dom -> 0
// Lun -> 1
// ....
// Sab -> 6

export default {
  name: "SettingsField",
  components: {ModalDelete, TitlePage},
  data() {
    return {
      description: '',
      tab: null,
      active: true,
      menu_ot: false,
      menu_ct: false,
      dialog_split_payment: false,
      dialog_slot_to_edit: false,
      dialog_slot_to_add: false,
      modalDelete: false,
      reset_time_slots: false,
      split_payment_types: [
        {'text': this.$t('payDivide'), 'value': 'pay_divide'},
        {'text': this.$t('payCenter'), 'value': 'pay_center'},
        {'text': this.$t('payOnline'), 'value': 'pay_online'}
      ],
      promotion_types: [
        {'text': '', 'value': null},
        {'text': this.$t('fixed'), 'value': 'fixed'},
        {'text': this.$t('percentage'), 'value': 'percentage'},
      ],
      split_payment_master_selected: '',
      split_payment_override_selected: '',
      override_title: '',
      edit_title: '',
      add_title: '',
      item: {
        rules: {
          slot_time: 60,
          open_time: '',
          close_time: '',
          limit_time: 60,
          calendar_days_view: 10,
          min_price: 0
        },
        availability: [
          [], [], [], [], [], [], []
        ],
        time_slots: [],
        price: [],
        split_payment_master: {
          online_percentage: 0,
          center_percentage: 0
        },
        master_calendar: null,
        master_calendar_enabled: null,
        half_hour_enabled: null,
        half_hour_price: [],
        enable_promo_code_promo_sa_global: false,
        enable_promo_code_promo_center: false
      },
      master_calendar_depth: 0,
      slot_to_override: null,
      slot_to_edit: null,
      slot_to_remove: null,
      slot_to_add: null,
      preview_price: [],
      preview_price_override: [],
      sports: [],
      headers: [
        {name: 'Lunedì', day: 1},
        {name: 'Martedì', day: 2},
        {name: 'Mercoledì', day: 3},
        {name: 'Giovedì', day: 4},
        {name: 'Venerdì', day: 5},
        {name: 'Sabato', day: 6},
        {name: 'Domenica', day: 0},
      ],
      check: true,
      errors: {},
      error_message: '',
      validation: {},
      pathCalendar: '/fields/calendar/' + this.$route.params.id,
      pathLiveCalendar: '/fields/live-calendar/' + this.$route.params.id,
      pathMasterCalendar: '/fields/master-calendar/' + this.$route.params.id,
      priceForSlots:[],
      center: null
    }
  },
  computed: {
    ...mapGetters({
      'getEndpoint': 'settings/getEndpoint',
      'getUser': 'user/getUser'
    }),
  },
  async created() {
    this.setLoading(true);
    this.sports = await this.getItemsSports()
    let fetchItem = await this.editItem(this.$route.params);
    this.center = JSON.parse(JSON.stringify(fetchItem.result.center))
    for (let i = 0; i < 7; i++) {
      if (fetchItem.result.master_calendar[i].length > this.master_calendar_depth) {
        this.master_calendar_depth = fetchItem.result.master_calendar[i].length
      }
    }

    this.item.master_calendar = (fetchItem.result.master_calendar) ? fetchItem.result.master_calendar : null
    this.item.master_calendar_enabled = (fetchItem.result.master_calendar_enabled) ? fetchItem.result.master_calendar_enabled : true
    this.item.half_hour_enabled = (fetchItem.result.half_hour_enabled) ? fetchItem.result.half_hour_enabled : false
    this.item.half_hour_price = (fetchItem.result.half_hour_price) ? fetchItem.result.half_hour_price : []

    this.description = fetchItem.result.name + ' [' + fetchItem.result.center.name + ']'

    _.assign(this.item.rules, fetchItem.result.rules);
    // _.assign(this.item.availability,fetchItem.result.availability);
    // _.assign(this.item.time_slots, fetchItem.result.time_slots);
    _.assign(this.item.price, fetchItem.result.price);

    this.item.split_payment_master.online_percentage = (fetchItem.result.split_payment_master) ? fetchItem.result.split_payment_master.online_percentage : 50.00
    this.item.split_payment_master.center_percentage = (fetchItem.result.split_payment_master) ? fetchItem.result.split_payment_master.center_percentage : 50.00

    if (!this.item.price || this.item.price.length === 0) {
      this.item.price = []
      fetchItem.result.sports.map((s) => {
        this.item.price.push({
          sport_id: s,
          value: 0.00
        })
      })
    }

    if (this.item.price.length !== fetchItem.result.sports.length) {
      fetchItem.result.sports.map((s) => {
        let check = _.find(this.item.price, (el) => {
          if (el.sport_id === s) {
            return true
          }
        });
        if (!check) {
          this.item.price.push({
            sport_id: s,
            value: 0.00
          })
        }
      })
    }

    this.priceForSlots = JSON.parse(JSON.stringify(this.item.price))

    if (!this.item.half_hour_price || this.item.half_hour_price.length === 0) {
      this.item.half_hour_price = []
      fetchItem.result.sports.map((s) => {
        this.item.half_hour_price.push({
          sport_id: s,
          value: 0.00
        })
      })
    }

    if (this.item.half_hour_price.length !== fetchItem.result.sports.length) {
      fetchItem.result.sports.map((s) => {
        let check = _.find(this.item.half_hour_price, (el) => {
          if (el.sport_id === s) {
            return true
          }
        });
        if (!check) {
          this.item.half_hour_price.push({
            sport_id: s,
            value: 0.00
          })
        }
      })
    }


    this.preview_price = []
    this.preview_price_override = []
    fetchItem.result.sports.map((s) => {
      this.preview_price.push({
        sport_id: s,
        value_ac: 0.00,
        value_ce: 0.00
      })
      this.preview_price_override.push({
        sport_id: s,
        value_ac: 0.00,
        value_ce: 0.00
      })
    })

    if (this.item.split_payment_master.center_percentage === 100 && this.item.split_payment_master.online_percentage === 0) {
      this.split_payment_master_selected = 'pay_center'
      await this.calculateTotals()
    } else if (this.item.split_payment_master.online_percentage === 100 && this.item.split_payment_master.center_percentage === 0) {
      this.split_payment_master_selected = 'pay_online'
      await this.calculateTotals()
    } else {
      this.split_payment_master_selected = 'pay_divide'
      await this.calculateTotals()
    }

    this.item.enable_promo_code_promo_sa_global = (fetchItem.result.enable_promo_code_promo_sa_global)
    this.item.enable_promo_code_promo_center = (fetchItem.result.enable_promo_code_promo_center)

    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'getItemsSports': 'sports/index',
      'editItem': 'fields/edit',
      'updateItem': 'fields/update',
    }),
    async update(redirect = null) {

      await this.checkItem()
      if (!this.check) {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: this.error_message
        })
        return
      } else {
        await this.resetError()
      }

      await this.setLoading(true);
      let result = await this.updateItem({...this.$route.params, item: this.item});
      await this.setLoading(false);

      if (result.success) {

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

        if (redirect === 'master') {
          this.goToMasterCalendar()
        } else if (redirect === 'calendar') {
          this.goTocalendar()
        }

      } else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }
    },
    async checkItem() {
      this.check = true
      this.error_message = ''
      if(this.item.half_hour_enabled){
        this.item.master_calendar.map((day,index) => {
          for(let slot of day){
            if(!this.check){
              return;
            }
            let slot_fixed = JSON.parse(JSON.stringify(slot))
            for(let other_slot of day){
              if(slot_fixed.id !== other_slot.id){
                let startTime1 = new Date(`1970/01/01 ${slot_fixed.start}`);
                let endTime1 = new Date(`1970/01/01 ${slot_fixed.end}`);
                let startTime2 = new Date(`1970/01/01 ${other_slot.start}`);
                let endTime2 = new Date(`1970/01/01 ${other_slot.end}`);
                if(startTime1 > endTime1){
                  endTime1.setDate(endTime1.getDate() + 1);
                }
                if(startTime2 > endTime2){
                  endTime2.setDate(endTime2.getDate() + 1);
                }
                if(startTime1 < endTime2 && endTime1 > startTime2){
                  this.check = false
                  this.error_message = `Non è possibile attivare l’opzione “Mezz’ora aggiuntiva”, perché il Calendario Master presenta fasce orarie sovrapposte. Disabilita tale opzione oppure modifica i seguenti slot sovrapposti nella sezione Calendario Master:
                  ${this.headers[index].name} ${slot_fixed.id.replace(';','-')} e ${other_slot.id.replace(';','-')}`
                  return;
                }
              }
            }
          }
        })
      }
      if(this.item.split_payment_master.online_percentage > 0 && (!this.center.configurations || (!this.center.configurations.paypal_enabled || this.center.configurations.paypal_client_id === '' || this.center.configurations.paypal_client_secret === ''))){
        this.check = false
        this.error_message = 'Non è possibile abilitare pagamenti online senza aver configurato correttamente un metodo di pagamento per il centro sportivo'
      }
    },
    async resetError() {
      this.errors = {}
      this.error_message = ''
    },
    async applySplit() {
      switch (this.split_payment_master_selected) {
        case "pay_divide": {
          this.item.split_payment_master.online_percentage = 50.00
          this.item.split_payment_master.center_percentage = 50.00
          await this.calculateTotals()
          break
        }
        case "pay_center": {
          this.item.split_payment_master.online_percentage = 0.00
          this.item.split_payment_master.center_percentage = 100.00
          await this.calculateTotals()
          break
        }
        case "pay_online": {
          this.item.split_payment_master.online_percentage = 100.00
          this.item.split_payment_master.center_percentage = 0.00
          await this.calculateTotals()
          break
        }
        default: {
          break
        }
      }
    },
    async changePercentage(type) {
      let total = 100.00;
      if (type === 'online') {
        if (+this.item.split_payment_master.online_percentage < 0) {
          this.item.split_payment_master.online_percentage = 0.00
          this.item.split_payment_master.center_percentage = 100.00
        } else if (+this.item.split_payment_master.online_percentage > 100) {
          this.item.split_payment_master.online_percentage = 100.00
          this.item.split_payment_master.center_percentage = 0.00
        } else {
          this.item.split_payment_master.center_percentage = +(total - (+this.item.split_payment_master.online_percentage))
        }
      } else if (type === 'center') {
        if (+this.item.split_payment_master.center_percentage < 0) {
          this.item.split_payment_master.center_percentage = 0.00
          this.item.split_payment_master.online_percentage = 100.00
        } else if (+this.item.split_payment_master.center_percentage > 100) {
          this.item.split_payment_master.center_percentage = 100.00
          this.item.split_payment_master.online_percentage = 0.00
        } else {
          this.item.split_payment_master.online_percentage = +(total - (+this.item.split_payment_master.center_percentage))
        }
      }
      await this.calculateTotals()
      this.$forceUpdate();
    },
    async calculateTotals() {
      this.preview_price.map((p) => {
        let price = _.find(this.item.price, {'sport_id': p.sport_id});
        if (price) {
          let unit = _.round(+price.value / 100, 3);
          let online = _.round(+unit * (+this.item.split_payment_master.online_percentage), 2);
          let center = _.round(+unit * (+this.item.split_payment_master.center_percentage), 2);
          p.value_ac = online
          p.value_ce = center
        }
      })
    },
    async enableSlot(slot){
      slot.active = !slot.active
      this.$forceUpdate();
    },
    async overrideSlot(day, timeslot) {
      this.split_payment_override_selected = ''
      this.override_title = ''
      let check = _.find(this.item.master_calendar[day], {'id': timeslot.id})
      if (check) {

        let day_week = _.find(this.headers, {'day': day})
        this.override_title = day_week.name + ' ' + check.start + ' - ' + check.end

        if (check.split_payment) {
          this.slot_to_override = {
            day: day,
            id: check.id,
            center_percentage: check.split_payment.center_percentage,
            online_percentage: check.split_payment.online_percentage,
            promo_value: (check.promo && check.promo.value) ? check.promo.value : 0.00,
            promo_type: (check.promo && check.promo.type) ? check.promo.type : null,
            slot_price: (check.slot_price) ? check.slot_price : null
          }

          if (+check.split_payment.center_percentage === 0) {
            this.split_payment_override_selected = 'pay_online'
          } else if (+check.split_payment.online_percentage === 0) {
            this.split_payment_override_selected = 'pay_center'
          } else {
            this.split_payment_override_selected = 'pay_divide'
          }

        } else {
          this.slot_to_override = {
            day: day,
            id: check.id,
            center_percentage: this.item.split_payment_master.center_percentage,
            online_percentage: this.item.split_payment_master.online_percentage,
            promo_value: 0.00,
            promo_type: null,
            slot_price: (check.slot_price) ? check.slot_price : null
          }

          if (+this.item.split_payment_master.center_percentage === 0) {
            this.split_payment_override_selected = 'pay_online'
          } else if (+this.item.split_payment_master.online_percentage === 0) {
            this.split_payment_override_selected = 'pay_center'
          } else {
            this.split_payment_override_selected = 'pay_divide'
          }


        }

        await this.calculateTotalsOverride()
        this.dialog_split_payment = true;
      }

    },
    async applySplitOverride() {
      switch (this.split_payment_override_selected) {
        case "pay_divide": {
          this.slot_to_override.online_percentage = 50.00
          this.slot_to_override.center_percentage = 50.00
          await this.calculateTotalsOverride()
          break
        }
        case "pay_center": {
          this.slot_to_override.online_percentage = 0.00
          this.slot_to_override.center_percentage = 100.00
          await this.calculateTotalsOverride()
          break
        }
        case "pay_online": {
          this.slot_to_override.online_percentage = 100.00
          this.slot_to_override.center_percentage = 0.00
          await this.calculateTotalsOverride()
          break
        }
        default: {
          break
        }
      }
    },
    async changePercentageOverride(type) {
      let total = 100.00
      if (type === 'online') {
        if (+this.slot_to_override.online_percentage < 0) {
          this.slot_to_override.online_percentage = 0.00
          this.slot_to_override.center_percentage = 100.00
        } else if (+this.slot_to_override.online_percentage > 100) {
          this.slot_to_override.online_percentage = 100.00
          this.slot_to_override.center_percentage = 0.00
        } else {
          this.slot_to_override.center_percentage = +(total - (+this.slot_to_override.online_percentage))
        }
      } else if (type === 'center') {
        if (+this.slot_to_override.center_percentage < 0) {
          this.slot_to_override.center_percentage = 0.00
          this.slot_to_override.online_percentage = 100.00
        } else if (+this.slot_to_override.center_percentage > 100) {
          this.slot_to_override.center_percentage = 100.00
          this.slot_to_override.online_percentage = 0.00
        } else {
          this.slot_to_override.online_percentage = +(total - (+this.slot_to_override.center_percentage))
        }
      }
      await this.calculateTotalsOverride()
      this.$forceUpdate();
    },
    async calculateTotalsOverride() {

      this.preview_price_override.map((p) => {
        let prices = (this.slot_to_override.slot_price) ? this.slot_to_override.slot_price : this.item.price
        let find = _.find(prices, {'sport_id': p.sport_id})
        let price = JSON.parse(JSON.stringify(find))

        if (this.slot_to_override.promo_type === 'fixed' && this.slot_to_override.promo_value >= 0.00) {
          price.value = price.value - this.slot_to_override.promo_value
        } else if (this.slot_to_override.promo_type === 'percentage' && this.slot_to_override.promo_value >= 0.00) {
          let discount_unit = _.round(+price.value / 100, 3);
          let discount = _.round(+discount_unit * (+this.slot_to_override.promo_value), 2);
          price.value = price.value - discount
        }

        let unit = _.round(+price.value / 100, 3);
        let online = _.round(+unit * (+this.slot_to_override.online_percentage), 2);
        let center = _.round(+unit * (+this.slot_to_override.center_percentage), 2);
        p.value_ac = online
        p.value_ce = center
      })
    },
    saveOverride() {
      let check = _.find(this.item.master_calendar[this.slot_to_override.day], {'id': this.slot_to_override.id})
      if (check) {
        if (this.slot_to_override.online_percentage != null && this.slot_to_override.center_percentage != null) {

          check.split_payment = {
            center_percentage: +this.slot_to_override.center_percentage,
            online_percentage: +this.slot_to_override.online_percentage,
          }

        } else {

          if (check.split_payment)
            delete check.split_payment

        }

        if (this.slot_to_override.promo_type != null && this.slot_to_override.promo_value >= 0.00) {
          check.promo = {
            type: this.slot_to_override.promo_type,
            value: +this.slot_to_override.promo_value
          }
        }

      }

      this.split_payment_override_selected = ''
      this.slot_to_override = null
      this.dialog_split_payment = false

    },
    deleteOverride() {
      let check = _.find(this.item.master_calendar[this.slot_to_override.day], {'id': this.slot_to_override.id})
      if (check) {
        delete check.split_payment
        if (check.promo) {
          delete check.promo
        }

      }
      this.split_payment_override_selected = ''
      this.slot_to_override = null
      this.dialog_split_payment = false
    },
    async generateTimeSlots() {
      let index
      let index_master_calendar
      let time = 0;
      let time_limit = 24 * 60;
      if (this.reset_time_slots) {
        index = 0
        index_master_calendar = 0
        this.item.time_slots = [];
        this.item.master_calendar = [
          [], [], [], [], [], [], []
        ]
      } else {
        index = this.item.time_slots.length
        index_master_calendar = this.item.time_slots.length
      }


      if (this.item.rules.open_time) {
        let timeOpen = new Date("01/01/2022 " + this.item.rules.open_time)
        time = timeOpen.getHours() * 60
        if (timeOpen.getMinutes() > 0) {
          time += timeOpen.getMinutes()
        }
      }

      if (this.item.rules.close_time) {
        let timeClose = new Date("01/01/2022 " + this.item.rules.close_time)

        if (timeClose.getHours() === 0) {
          this.item.rules.close_time = "23:59"
          timeClose = new Date("01/01/2022 " + this.item.rules.close_time)
        }

        time_limit = timeClose.getHours() * 60

        if (timeClose.getMinutes() > 0) {
          time_limit += timeClose.getMinutes()
        }
      }

      for (index; time < time_limit; index++) {

        let time_end = time + (+this.item.rules.slot_time);

        let hh = Math.floor(time / 60);
        let mm = (time % 60);

        let hh_end = Math.floor(time_end / 60);
        let mm_end = (time_end % 60);

        let start = ("0" + (hh % 24)).slice(-2) + ':' + ("0" + mm).slice(-2)
        let end = ("0" + (hh_end % 24)).slice(-2) + ':' + ("0" + mm_end).slice(-2)

        this.item.time_slots[index] = {
          'start': start,
          'end': end,
          'id': start + ';' + end
        }

        time = time + (+this.item.rules.slot_time);
      }

      for (index_master_calendar; index_master_calendar < this.item.time_slots.length; index_master_calendar++) {
        for (let i = 0; i < 7; i++) {
          let new_slot = JSON.parse(JSON.stringify(this.item.time_slots[index_master_calendar]))
          new_slot.active = false
          new_slot.slot_price = JSON.parse(JSON.stringify(this.priceForSlots))
          this.item.master_calendar[i].push(new_slot)
        }
      }

      this.master_calendar_depth = this.item.time_slots.length

      for(let j = 0; j < 7; j++){
        let daySlots = JSON.parse(JSON.stringify(this.item.master_calendar[j]))
        this.item.master_calendar[j] = _.orderBy(daySlots, ['start', 'end'], ['asc', 'asc']);
      }


      this.reset_time_slots = false
      this.$forceUpdate();
    },
    editSlot(day, timeslot) {
      this.edit_title = ''
      let find = _.find(this.item.master_calendar[day], {'id': timeslot.id})
      if (find) {
        let day_week = _.find(this.headers, {'day': day})
        this.edit_title = day_week.name + ' ' + find.start + ' - ' + find.end
        this.slot_to_edit = JSON.parse(JSON.stringify(find))
        this.slot_to_edit.day = day
        let split_start = this.slot_to_edit.start.split(':')
        let split_end = this.slot_to_edit.end.split(':')
        this.slot_to_edit.start_h = split_start[0]
        this.slot_to_edit.start_m = split_start[1]
        this.slot_to_edit.end_h = split_end[0]
        this.slot_to_edit.end_m = split_end[1]
        if (find.slot_price) {
          find.slot_price.map((p) => {
            p.value = +p.value
          })
          this.slot_to_edit.slot_price = find.slot_price
        } else {
          this.slot_to_edit.slot_price = JSON.parse(JSON.stringify(this.item.price))
          this.slot_to_edit.slot_price.map((p) => {
            let minutes = this.getSlotDurationInMinutes('edit')
            let unit = _.round(+p.value / this.item.rules.slot_time, 3);
            p.value = _.round(+unit * (+minutes), 2);
          })
        }
        this.dialog_slot_to_edit = true;
      }
    },
    addNewSlot(day, timeslot) {
      this.add_title = ''
      let find = _.find(this.item.master_calendar[day], {'id': timeslot.id})
      if (find) {
        let day_week = _.find(this.headers, {'day': day})
        this.add_title = 'Aggiungi Slot ' + day_week.name
        this.slot_to_add = JSON.parse(JSON.stringify(find))
        this.slot_to_add.day = day
        let split_start = this.slot_to_add.start.split(':')
        let split_end = this.slot_to_add.end.split(':')
        this.slot_to_add.start_h = split_start[0]
        this.slot_to_add.start_m = split_start[1]
        this.slot_to_add.end_h = split_end[0]
        this.slot_to_add.end_m = split_end[1]
        if (find.slot_price) {
          find.slot_price.map((p) => {
            p.value = +p.value
          })
          this.slot_to_add.slot_price = find.slot_price
        } else {
          this.slot_to_add.slot_price = JSON.parse(JSON.stringify(this.item.price))
          this.slot_to_add.slot_price.map((p) => {
            let minutes = this.getSlotDurationInMinutes('add')
            let unit = _.round(+p.value / this.item.rules.slot_time, 3);
            p.value = _.round(+unit * (+minutes), 2);
          })
        }
        this.slot_to_add.slot_price = (find.slot_price) ? find.slot_price : JSON.parse(JSON.stringify(this.item.price))
        this.dialog_slot_to_add = true;
      }
    },
    confirmRemove(day, timeslot) {
      this.slot_to_remove = {
        day: day,
        timeslot: timeslot
      }
      this.modalDelete = true
      this.typeDelete = 'single'
    },
    removeSlot() {
      let arrayDay = JSON.parse(JSON.stringify(this.item.master_calendar[this.slot_to_remove.day]))
      this.item.master_calendar[this.slot_to_remove.day] = _.remove(arrayDay, (slot) => slot.id !== this.slot_to_remove.timeslot.id);
      this.slot_to_remove = null
      this.modalDelete = false
      this.$forceUpdate();
    },
    insertSlotUpdated() {
      let start_time = ("0" + (this.slot_to_edit.start_h % 24)).slice(-2) + ':' + ("0" + this.slot_to_edit.start_m).slice(-2)
      let end_time = ''
      if (this.slot_to_edit.end_h === 0) {
        end_time = "23:59"
      } else {
        end_time = ("0" + (this.slot_to_edit.end_h % 24)).slice(-2) + ':' + ("0" + this.slot_to_edit.end_m).slice(-2)
      }

      let diff = Math.abs(new Date('2022/01/01 ' + end_time) - new Date('2022/01/01 ' + start_time));
      if (Math.floor((diff / 1000) / 60) > 0) {

        let find = _.find(this.item.master_calendar[this.slot_to_edit.day], {'id': this.slot_to_edit.id})
        if (find) {
          find.start = start_time
          find.end = end_time
          find.id = start_time + ';' + end_time
          find.slot_price = (JSON.stringify(this.slot_to_edit.slot_price) !== JSON.stringify(this.item.price)) ? this.slot_to_edit.slot_price : null
        }
        this.slot_to_edit = null
        this.dialog_slot_to_edit = false
      }
    },
    insertSlotToAdd() {
      let start_time = ("0" + (this.slot_to_add.start_h % 24)).slice(-2) + ':' + ("0" + this.slot_to_add.start_m).slice(-2)
      let end_time = ''
      if (this.slot_to_add.end_h === 0) {
        end_time = "23:59"
      } else {
        end_time = ("0" + (this.slot_to_add.end_h % 24)).slice(-2) + ':' + ("0" + this.slot_to_add.end_m).slice(-2)
      }

      let diff = Math.abs(new Date('2022/01/01 ' + end_time) - new Date('2022/01/01 ' + start_time));
      if (Math.floor((diff / 1000) / 60) > 0) {

        let daySlots = JSON.parse(JSON.stringify(this.item.master_calendar[this.slot_to_add.day]))
        daySlots.push({
          start: start_time,
          end: end_time,
          id: start_time + ';' + end_time,
          active: true,
          slot_price: (JSON.stringify(this.slot_to_add.slot_price) !== JSON.stringify(this.item.price)) ? this.slot_to_add.slot_price : null
        })

        this.item.master_calendar[this.slot_to_add.day] = _.orderBy(daySlots, ['start', 'end'], ['asc', 'asc']);

        if (this.item.master_calendar[this.slot_to_add.day].length > this.master_calendar_depth) {
          this.master_calendar_depth = this.item.master_calendar[this.slot_to_add.day].length
        }

        this.slot_to_add = null
        this.dialog_slot_to_add = false
      }
    },
    calculateSlotTotals(mode) {
      let obj = (mode === 'add') ? this.slot_to_add : this.slot_to_edit
      obj.slot_price = JSON.parse(JSON.stringify(this.item.price))
      obj.slot_price.map((p) => {
        let minutes = this.getSlotDurationInMinutes(mode)
        let unit = _.round(+p.value / this.item.rules.slot_time, 3);
        p.value = _.round(+unit * (+minutes), 2);
      })
      this.$forceUpdate();
    },
    getSportName(_id) {
      let find = _.find(this.sports, {'_id': _id})
      if (find) {
        return find.name
      } else {
        return _id
      }
    },
    getSlotDurationInMinutes(mode) {
      let obj = (mode === 'edit') ? this.slot_to_edit : this.slot_to_add
      let start_time = ("0" + (obj.start_h % 24)).slice(-2) + ':' + ("0" + obj.start_m).slice(-2)
      let end_time = ''
      if (obj.end_h === "00" && obj.end_m === "00") {
        end_time = "23:59"
      } else {
        end_time = ("0" + (obj.end_h % 24)).slice(-2) + ':' + ("0" + obj.end_m).slice(-2)
      }
      let diff = Math.abs(new Date('2022/01/01 ' + end_time) - new Date('2022/01/01 ' + start_time));
      return Math.floor((diff / 1000) / 60);
    },
    goTocalendar() {
      this.$router.push(this.pathLiveCalendar)
    },
    goToMasterCalendar() {
      this.$router.push(this.pathMasterCalendar)
    },
    addAll(index) {
      if (this.item.master_calendar[index].filter(e => !e.active).length === 0) {
        this.item.master_calendar[index].map((s) => {
          s.active = false
        })
      } else {
        this.item.master_calendar[index].map((s) => {
          s.active = true
        })
      }

      this.$forceUpdate();
    },
    removeHandler(mode) {
      if (this.typeDelete == 'single') {
        this.removeSlot(mode)
      } else {
        this.modalDelete = false
        this.slot_to_remove = null
        this.typeDelete = ''
      }
    },
  }
  ,
  mounted() {

  }
}
</script>

<style>
</style>